import { ReactNode } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import Reauthenticate from '@/lib/Reauthenticate';
import { tokenName, useToken } from '@/utils/token';

const TokenGuard = ({ children }: { children: ReactNode }) => {
  const { token, tokenContent } = useToken();
  const nowSeconds = Math.round(Date.now() / 1000);
  const tokenIsExpired = !token || (tokenContent ? tokenContent.exp <= nowSeconds : true);

  if (tokenIsExpired) {
    // Diagnostic: helps identify whether the loop is caused by a missing token
    // (e.g. localStorage unavailable) vs. a genuinely expired token.
    const tokenInStorage = localStorage.getItem(tokenName);
    datadogRum.addAction('enterprise::token-guard::reauthenticating', {
      hasToken: !!token,
      hasTokenContent: !!tokenContent,
      tokenInStorage: !!tokenInStorage,
      exp: tokenContent?.exp ?? null,
      nowSeconds,
      deltaSeconds: tokenContent ? tokenContent.exp - nowSeconds : null,
    });
  }

  return tokenIsExpired ? <Reauthenticate /> : children;
};

export default TokenGuard;
